import { getClient } from '@/lib/restClient';
import { StoreManagementStoreService } from '@/services/StoreManagement/AuthStores/StoreManagementStoreService';

export const useStoreManagementAuthStoreDelete = async (
  id: number
): Promise<void> => {
  const storeManagementStoreService = new StoreManagementStoreService(
    getClient()
  );
  return await storeManagementStoreService.delete(id);
};
